<template>
  <div class="tooth-position-section">
    <div v-if="question.selectedToothNumber" class="tooth-selection-results">
      <div class="selection-info">
        <strong>Selected Tooth:</strong> {{ question.selectedToothNumber }}
      </div>
      <button class="btn-select edit" @click="$emit('show-tooth-selector')">
        <svg class="btn-icon" width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" /></svg>
        Change Selection
      </button>
    </div>
    <div v-else class="tooth-selection-prompt">
      <p>Please select a tooth before continuing.</p>
      <button class="btn-select" @click="$emit('show-tooth-selector')">
        <svg class="btn-icon" width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="M12 2C7.31 2 3.5 5.81 3.5 10.5c0 2.07.77 3.98 2.04 5.43.34.37.77 1.07.77 1.57v2c0 1.1.9 2 2 2h7.38c1.1 0 2-.9 2-2v-2c0-.5.43-1.2.77-1.57 1.27-1.45 2.04-3.36 2.04-5.43 0-4.69-3.81-8.5-8.5-8.5zm2.7 12.3c-.53.4-1.2 1.22-1.2 2.2v2H10.5v-2c0-.98-.67-1.8-1.2-2.2-1.01-1.15-1.8-2.71-1.8-4.3 0-3.31 2.69-6 6-6s6 2.69 6 6c0 1.59-.79 3.15-1.8 4.3z" /></svg>
        Select Tooth
      </button>
    </div>

    <!-- The ResponseGrid is only shown after a tooth has been selected -->
    <ResponseGrid
      v-if="question.selectedToothNumber"
      :responses="sortedResponses"
      :is-disabled="!question.selectedToothNumber"
      @select-response="$emit('select-response', $event)"
      @show-image="$emit('show-image', $event)"
      @show-information="$emit('show-information', $event)"
    />
  </div>
</template>

<script>
import ResponseGrid from './ResponseGrid.vue';

export default {
  name: 'ToothPositionQuestion',
  components: {
    ResponseGrid,
  },
  props: {
    question: {
      type: Object,
      required: true,
    },
  },
  emits: ['select-response', 'show-tooth-selector', 'show-image', 'show-information'],
  computed: {
    sortedResponses() {
      return [...this.question.responses].sort((a, b) => a.position - b.position);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../breakpoints.scss";

.tooth-position-section {
  padding: 16px;

  .tooth-selection-prompt {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 15px 0;
    text-align: center;
    background: #F9FAFB;
    border: 1px dashed #D1D5DB;
    border-radius: 8px;
    padding: 20px;

    p {
      margin-bottom: 15px;
      font-weight: 500;
      color: #000001;
    }
  }

  .tooth-selection-results {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;
    background: #F9FAFB;
    border-radius: 8px;
    padding: 16px;

    @include md {
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }

    .selection-info {
      margin-bottom: 15px;
      font-size: 16px;
      color: #111827;
      background: white;
      border-radius: 6px;
      padding: 8px 16px;
      display: inline-block;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);

      @include md {
        margin-bottom: 0;
        margin-right: 20px;
      }
    }
  }

  .btn-select {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px 20px;
    border-radius: 8px;
    font-weight: 600;
    font-size: 15px;
    transition: all 0.2s ease;
    cursor: pointer;
    border: none;
    background: linear-gradient(135deg, #013B82, #0A2D5C);
    color: white;
    box-shadow: 0 2px 6px rgba(1, 59, 130, 0.2);

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 8px rgba(1, 59, 130, 0.3);
    }

    &:active {
      transform: translateY(0);
      box-shadow: 0 2px 4px rgba(1, 59, 130, 0.2);
    }

    &.edit {
      background: linear-gradient(135deg, #000001, #374151);
      padding: 8px 16px;
      font-size: 14px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

      &:hover {
        background: linear-gradient(135deg, #374151, #1F2937);
      }
    }

    .btn-icon {
      flex-shrink: 0;
    }
  }
}
</style>